import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import SchedulingQuestions from './SchedulingQuestions'
import InHomeSchedulingButtons from './InHomeSchedulingButtons';
import AppointmentOverview from './AppointmentOverview';
import StickyProgressBar from '../common/StickyProgressBar';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import { Grid, Typography, LinkText, Divider, Card, Icon } from "../ecosystem/";
import * as msgs from "../../constants/textConstants";

const InHomeWhoConfirm = ({ history, selectedUsers, engageHelpDeskNumber, screenBreakPoint }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhoConfirm.Displayed`, new Date(), Tools.getURLPath());
    }, []);

    const onClickPrevious = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhoConfirm.Previous.Clicked`, new Date(), Tools.getURLPath())
        history.push("/inhomeschedules");
    }

    const onClickNext = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhoConfirm.Next.Clicked`, new Date(), Tools.getURLPath())
        history.push("/inhomeschedule/s3")
    }


    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET || screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP) ? true : false;

    return (
        <>
            {selectedUsers?.length < 1 ?
                <Redirect to='/inhomeschedules' /> :
                <>
                    <StickyProgressBar className="inhome" widthInPercent={1 / 6 * 100} />
                    <Grid className="body-content body-content--no-top-offset inhome inhome-scheduling inhome-scheduling-who-confirm-container">
                        <div className="">
                            <div className={`${isMobileSize ? 'col-12' : ''}`}>
                                <div className={`${isMobileSize ? 'row flex' : 'flex-desktop'}`}>
                                    <div className="in-home-left-panel">
                                        <div className="row in-home-left-detail">
                                            <div className="detail-wrapper who-confirm-detail-wrapper">
                                            <Typography
                                                type="heading-06"
                                                color={"$color-primary-a2"}
                                            >
                                                Is this correct?
                                            </Typography>
                                            <div className="detail-sub-content">
                                                <Typography
                                                    type="body-02"
                                                    color={"$color-secondary-a2"}
                                                >
                                                    Please confirm that the information that we have for each person receiving a vaccine is correct.
                                                </Typography>
                                            </div>
                                            <div className="recipient-details-wrapper">
                                                {selectedUsers?.length && selectedUsers.map((u, i) => {
                                                    return <div key={i}>  <Typography
                                                        type="body-03"
                                                        bold
                                                        color={"$color-secondary-a2"}
                                                    >Recipient {i + 1}</Typography>
                                                        <div className="recipient-details" >
                                                            <Card className="recipient-details-item" to='/inhomeschedules'>
                                                                <div>
                                                                <div>
                                                                    <Typography
                                                                        type="body-02"
                                                                        bold
                                                                        color={"$color-primary-a2"}
                                                                    >
                                                                        First Name:
                                                                        <Typography
                                                                            type="body-02"
                                                                            tag="span"
                                                                            color={"$color-primary-a2"}
                                                                        >
                                                                            {u.firstName}
                                                                        </Typography>
                                                                    </Typography>
                                                                </div>
                                                                <div>
                                                                    <Typography
                                                                        type="body-02"
                                                                        bold
                                                                        color={"$color-primary-a2"}
                                                                    >
                                                                        Last Name:
                                                                        <Typography
                                                                            type="body-02"
                                                                            tag="span"
                                                                            color={"$color-primary-a2"}
                                                                        >
                                                                            {u.dob}
                                                                        </Typography>
                                                                    </Typography>
                                                                </div>
                                                                <div>
                                                                    <Typography
                                                                        type="body-02"
                                                                        bold
                                                                        color={"$color-primary-a2"}
                                                                    >
                                                                        Date of Birth:

                                                                    </Typography>
                                                                    </div>
                                                                </div>
                                                                <div className="recipient-details-icon">
                                                                    <Icon name="edit" />
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                })}
                                                </div>
                                            
                                            <Divider mTop="large" mBottom="xlarge" mLeft="none" mRight="none" />
                                            <InHomeConfirmationModal />
                                            </div>
                                        </div>
                                        <div className="row in-home-left-detail">
                                        <SchedulingQuestions />
                                        </div>
                                        < InHomeSchedulingButtons
                                            leftOnClick={onClickPrevious}
                                            rightOnClick={onClickNext}
                                        >
                                        </InHomeSchedulingButtons>
                                    </div>
                                    <div className="in-home-right-panel">
                                        <AppointmentOverview recipientsPhase={true} />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Grid>
                </>
            }
        </>
    );
}

const mapStateTopProps = state => {
    return {
        selectedUsers: state.inHome.selectedUsers,
        engageHelpDeskNumber: state.session.serverData?.engageHelpDeskNumber || '833.466.3020',
        screenBreakPoint: state.common.screenBreakPoint,
    }
}


export default connect(mapStateTopProps)(InHomeWhoConfirm);